import { redirect } from "react-router";
import { useParticipantJoinStore } from "../ParticipantJoinView/ParticipantJoinView.store";

export function participantJoinVerifyLoader() {
  if (!useParticipantJoinStore.getState().maskedEmail) {
    return redirect("..");
  }
  return null;
}
